/**
 * @owner @Appboy/whats-app
 */
import { z } from "zod";
import { whatsAppResponseMessageCommonSchema } from "@schemas/message/whatsAppResponseMessageCommonSchema";

// refer to WhatsAppResponseMessageRequestContactInfoExport
export const whatsAppResponseRequestContactInfoMessageSchema = z.object({
  ...whatsAppResponseMessageCommonSchema.shape,
  layout: z.literal("request-contact-info"),
  body: z.string().nullable(),
});
